const userRoles = {
  superAdmin: 'ROLE_SUPER_ADMIN',
  admin: 'ROLE_ADMIN',
  user: 'ROLE_USER',
  operator: 'ROLE_CALL_CENTER',
};

export default userRoles;
